import {Box} from 'quickstart/components/layout/Box'
import styled, {css, system, th} from 'quickstart/system'
import {toLongId} from 'tizra'

export const FakeCover = styled(Box)(
  ({aspectRatio, bordered, hoverable, shadowed, theme, tizraId}) => {
    // Default to zero in case toLongId returns NaN.
    const i = (toLongId(tizraId) || 0) % theme.fakeCovers.length
    return css`
      ${th(`fakeCovers.${i}`)};
      aspect-ratio: ${aspectRatio ?? 'auto'};
      ${bordered && th('images.bordered')};
      ${shadowed && th('images.shadowed')};
      ${hoverable && th('images.hoverable')};
      ${system};
    `
  },
)
